// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationItem__navigationItem___ahNFK {
    cursor: pointer;

    display: flex;
    flex-direction: row;
    gap: var(--space-xs);
    align-items: center;

    height: var(--control-height-s);
    padding: var(--space-2xs) var(--space-xs);

    font-size: 1.3rem;
    font-weight: var(--font-weight-text-medium);
    color: var(--color-typo-secondary);
    text-decoration: none;

    background-color: var(--color-control-bg-clear);
    border: none;
    border-radius: 0.6rem;

    &:hover {
        background-color: var(--color-control-bg-clear-hover);
    }

    &[aria-selected='true'],
    &.NavigationItem__active___vqMMk {
        color: var(--color-typo-primary);
        background-color: var(--color-control-bg-clear-hover);
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/NavigationSidebar/NavigationItem/NavigationItem.css"],"names":[],"mappings":"AAAA;IACI,eAAe;;IAEf,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;;IAEnB,+BAA+B;IAC/B,yCAAyC;;IAEzC,iBAAiB;IACjB,2CAA2C;IAC3C,kCAAkC;IAClC,qBAAqB;;IAErB,+CAA+C;IAC/C,YAAY;IACZ,qBAAqB;;IAErB;QACI,qDAAqD;IACzD;;IAEA;;QAEI,gCAAgC;QAChC,qDAAqD;IACzD;AACJ","sourcesContent":[".navigationItem {\n    cursor: pointer;\n\n    display: flex;\n    flex-direction: row;\n    gap: var(--space-xs);\n    align-items: center;\n\n    height: var(--control-height-s);\n    padding: var(--space-2xs) var(--space-xs);\n\n    font-size: 1.3rem;\n    font-weight: var(--font-weight-text-medium);\n    color: var(--color-typo-secondary);\n    text-decoration: none;\n\n    background-color: var(--color-control-bg-clear);\n    border: none;\n    border-radius: 0.6rem;\n\n    &:hover {\n        background-color: var(--color-control-bg-clear-hover);\n    }\n\n    &[aria-selected='true'],\n    &.active {\n        color: var(--color-typo-primary);\n        background-color: var(--color-control-bg-clear-hover);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigationItem": `NavigationItem__navigationItem___ahNFK`,
	"active": `NavigationItem__active___vqMMk`
};
export default ___CSS_LOADER_EXPORT___;
